var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{domProps:{"innerHTML":_vm._s(_vm.buttonText)},on:{"click":_vm.doUpdateCoverage}})
}
var staticRenderFns = []

export { render, staticRenderFns }